var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"scrollChart"},[_c('ScrollChart',{attrs:{"scrImg":_vm.scrImg}})],1),_c('div',{staticClass:"contentbotton"},[_c('div',{staticClass:"left"},[_c('menuLeft',{attrs:{"formdata":_vm.formdata},on:{"gettype":_vm.handleSelect}})],1),_c('div',{staticClass:"right"},[_c('router-view')],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }